import { END_POINTS } from "../constants/urls";
import { CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

export const transactionsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        limit?: number;
        page?: number;
      }
    >({
      query: ({ page, limit, search }) => {
        const params = new URLSearchParams();

        params.append("page", String(page));
        params.append("limit", String(limit));

        if (search) params.append("search", search);
        return {
          url: `${END_POINTS.getTransactions}?${params.toString()}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useLazyGetTransactionsQuery } = transactionsApi;
